import Box from "ui-box";

export const Pane = Box;
